import React from "react";
import PropTypes from "prop-types";
import { useTheme } from "../../../providers/theme-provider";
import { fontSizes } from "../../../theme/font-sizes";
import spacings from "../../../theme/spacings";

function CtaButton({ label, onClick = () => {}, style = {} }) {
  const { colors } = useTheme();

  return (
    <button
      onClick={onClick}
      style={{
        // margin: "10px",
        backgroundColor: colors.mainHeading,
        color: colors.buttonText,
        fontSize: fontSizes.body,
        padding: `${spacings.topBottomCtaButton}px ${spacings.leftRightCtaButton}px`,
        borderRadius: 5,
        cursor: "pointer",
        ...style,
      }}
    >
      {label}
    </button>
  );
}

CtaButton.propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  style: PropTypes.object,
};

export default CtaButton;
